import { qq } from 'bobjoll/ts/library/dom';

qq('.article-body img').forEach(image => {
    const parent = image.parentElement;
    const check = image.parents('figure, .banner--img, .freebies');

    if (parent && check.length === 0) {
        const figure = document.createElement('figure');
        figure.appendChild(image);
        parent.appendChild(figure);
    }
});